import { defineExternalSignals } from "../core/composition/define-external-signals.js";
import { defineFeature } from "../core/composition/define-feature.js";
import { attachMediaSourceAsSourceElement } from "../media/dom/mse/mediasource-setup.js";
import { setupAirPlay } from "../behaviors/dom/airplay.js";
//#region src/playback/features/airplay.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [setupAirPlay, defineExternalSignals()({ state: ["disableRemotePlayback"] })];
/** The config defaults the feature contributes. */
const defaultConfig = { attachMediaSource: attachMediaSourceAsSourceElement };
/** The state values the feature seeds. */
const initialState = {};
/**
* Plays to AirPlay receivers (WebKit only; inert elsewhere), unless the user sets `disableRemotePlayback`. Attaches the
* MediaSource through a `<source>` element, which the native fallback the receiver plays requires.
*
* Requires a writer of `context.mediaSource`, such as `mediaSourceFeature`; without one, AirPlay is never offered.
*/
const airPlayFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { airPlayFeature, behaviors, defaultConfig, initialState };
